<template>
  <div class="animated fadeIn" id="library">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i>
        <strong>Gestion des Boîtes aux lettres</strong>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col cols="6">
            <b-card no-body v-for="(bals, key) of groupBals" :key="key">
              <b-card-header>
                <i class="fa fa-list mr-2"></i>
                <strong>Liste des Boîtes aux lettres {{ key.toUpperCase() }}</strong>
              </b-card-header>
              <b-card-body>
                <SlickList  lockAxis="y" v-model="groupBals[key]" class="list-group" :useDragHandle="true" @sort-end="sorted()">
                  <div v-for="(bal, index) in bals" :key="index">
                  <handleSlickItem  :index="index"  :item="bal" :groupKey="key" :id="`item-${bal.id}`" role="tab" :class="`block-${key} `">
                    {{ bal.nom }} <i v-if="canManage()" class="fa fa-trash pull-right text-danger" @click="removeBal(bal.id)"></i></handleSlickItem>
                    <b-collapse :id="`collapse-${bal.id}`" class="mt-2" :accordion="`accordion-${key}`" role="tabpanel">
                      <b-card>
                        <p :id="`infosMail-${bal.id}`" class="card-text">
                          <i v-if="canManage()" class="fa fa-pencil pull-right clickable" @click="showEditBal(bal)"></i>
                          Host : {{ bal.host }}<br>
                          Port : {{ bal.port }}<br>
                          Login : {{ bal.login }}<br>
                          Encryption : {{ bal.encryption }}<br>
                          Validation du certificat : {{ bal.validate_cert }}<br>
                          Protocol : {{ bal.protocol }}<br>
                          OAG : {{ bal.oag ? bal.oag.code : '' }}<br>
                          OAP : {{ bal.oap ? bal.oap.code : '' }}<br>
                        </p>
                        <p :id="`editMail-${bal.id}`" class="card-text d-none">
                          <b-row class="my-1">
                            <b-col sm="3">
                              <label for="input-small">Nom :</label>
                            </b-col>
                            <b-col sm="9">
                              <b-form-input v-model="nom" size="sm" placeholder="Entrer le nom de votre configuration" :class="{hasError: errors.nom !== ''}"></b-form-input>
                              <span class='field-error'>{{ errors.nom }}</span>
                            </b-col>
                          </b-row>
                          <b-row class="my-1">
                            <b-col sm="3">
                              <label for="input-small">Host :</label>
                            </b-col>
                            <b-col sm="9">
                              <b-form-input v-model="host" size="sm" placeholder="Entrer l'Host de votre serveur mail" :class="{hasError: errors.host !== ''}"></b-form-input>
                              <span class='field-error'>{{ errors.host }}</span>
                            </b-col>
                          </b-row>
                          <b-row class="my-1">
                            <b-col sm="3">
                              <label for="input-small">Port :</label>
                            </b-col>
                            <b-col sm="9">
                              <b-form-input v-model="port" size="sm" placeholder="Entrer le port de votre serveur mail" :class="{hasError: errors.port !== ''}"></b-form-input>
                              <span class='field-error'>{{ errors.port }}</span>
                            </b-col>
                          </b-row>
                          <b-row class="my-1">
                            <b-col sm="3">
                              <label for="input-small">Login :</label>
                            </b-col>
                            <b-col sm="9">
                              <b-form-input v-model="login" size="sm" placeholder="Entrer le login de votre compte mail" :class="{hasError: errors.login !== ''}"></b-form-input>
                              <span class='field-error'>{{ errors.login }}</span>
                            </b-col>
                          </b-row>
                          <b-row class="my-1">
                            <b-col sm="3">
                              <label for="input-small">Mot de passe :</label>
                            </b-col>
                            <b-col sm="9">
                              <b-form-input v-model="mdp" size="sm" placeholder="Entrer le mot de passe de votre compte mail" :class="{hasError: errors.mdp !== ''}"></b-form-input>
                              <span class='field-error'>{{ errors.mdp }}</span>
                            </b-col>
                          </b-row>
                          <b-row class="my-1">
                            <b-col sm="3">
                              <label for="input-small">Protocol :</label>
                            </b-col>
                            <b-col sm="9">
                              <b-form-select size="sm" v-model="protocol" :options="optionsProtocol" disabled></b-form-select>
                              <span class='field-error'>{{ errors.protocol }}</span>
                            </b-col>
                          </b-row>
                          <b-row class="my-1">
                            <b-col sm="12">
                              <b-form-checkbox-group v-model="encryption" id="encryption" >
                                <b-form-checkbox size="sm" value="encryption" disabled>Activer l'encryption</b-form-checkbox>
                              </b-form-checkbox-group>
                            </b-col>
                          </b-row>
                          <b-row class="my-1">
                            <b-col sm="12">
                              <b-form-checkbox-group v-model="validate_cert" id="cert" >
                                <b-form-checkbox size="sm" value="cert" disabled>Activer la validation de certificat</b-form-checkbox>
                              </b-form-checkbox-group>
                            </b-col>
                          </b-row>
                          <b-row class="my-1">
                            <b-col sm="3">
                              <label for="input-small">OAG :</label>
                            </b-col>
                            <b-col sm="9">
                              <b-form-select size="sm" v-model="selectedOag" :options="optionsOags" :class="{hasError: errors.oag !== ''}"></b-form-select>
                              <span class='field-error'>{{ errors.oag }}</span>
                            </b-col>
                          </b-row>
                          <b-row class="my-1">
                            <b-col sm="3">
                              <label for="input-small">OAP :</label>
                            </b-col>
                            <b-col sm="9">
                              <b-form-select size="sm" v-model="selectedOap" :options="optionsOaps" :class="{hasError: errors.oap !== ''}"></b-form-select>
                              <span class='field-error'>{{ errors.oap }}</span>
                            </b-col>
                          </b-row>
                          <button type="button" @click="modifyBal(bal)" class="btn btn-primary  pull-right">Valider</button>
                          <button type="button" @click="cancelEditBal(bal)" class="btn btn-light pull-right mr-2">Annuler</button>
                        </p>
                      </b-card>
                    </b-collapse>
                  
                  </div>
                </SlickList >
              </b-card-body>
            </b-card>
          </b-col>
          <b-col cols="6">
            <b-row>
              <b-col cols="12">
                <b-button type="button" class="" size="md" variant="primary" @click="ajoutBal" v-if="canManage()">
                    <i class="fa fa-plus"></i> Ajouter une boîte aux lettres
                </b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-collapse id="collapse-newBal" class="mt-2">
                  <b-card>
                    <b-form-group
                      id="input-group-nom"
                      label="Nom :"
                      label-for="nom"
                    >
                      <b-form-input
                        id="nom"
                        v-model="nom"
                        type="text"
                        required
                        placeholder="Entrer le nom de votre configuration"
                        :class="{hasError: errors.nom !== ''}"
                      ></b-form-input>
                      <span class='field-error'>{{ errors.nom }}</span>
                    </b-form-group>
                    <b-form-group
                      id="input-group-host"
                      label="Host :"
                      label-for="host"
                    >
                      <b-form-input
                        id="host"
                        v-model="host"
                        type="text"
                        required
                        placeholder="Entrer l'Host de votre serveur mail"
                        :class="{hasError: errors.host !== ''}"
                      ></b-form-input>
                      <span class='field-error'>{{ errors.host }}</span>
                    </b-form-group>
                    <b-form-group
                      id="input-group-port"
                      label="Port :"
                      label-for="port"
                    >
                      <b-form-input
                        id="port"
                        v-model="port"
                        type="number"
                        required
                        placeholder="Entrer le port de votre serveur mail"
                      :class="{hasError: errors.port !== ''}"
                      ></b-form-input>
                      <span class='field-error'>{{ errors.port }}</span>
                    </b-form-group>
                    <b-form-group
                      id="input-group-login"
                      label="Login :"
                      label-for="login"
                    >
                      <b-form-input
                        id="login"
                        v-model="login"
                        type="text"
                        required
                        placeholder="Entrer le login de la boîte mail"
                      :class="{hasError: errors.login !== ''}"
                      ></b-form-input>
                      <span class='field-error'>{{ errors.login }}</span>
                    </b-form-group>
                    <b-form-group
                      id="input-group-mdp"
                      label="Mot de passe :"
                      label-for="mdp"
                    >
                      <b-form-input
                        id="mdp"
                        v-model="mdp"
                        type="password"
                        required
                        placeholder="Entrer le mot de passe du compte"
                      :class="{hasError: errors.mdp !== ''}"
                      ></b-form-input>
                      <span class='field-error'>{{ errors.mdp }}</span>
                    </b-form-group>
                    <b-form-group
                      id="input-group-encryption"
                      label="Encryption"
                      label-for="encryption"
                    >
                      <b-form-checkbox-group v-model="encryption" id="encryption" disabled>
                        <b-form-checkbox value="encryption">Activer l'encryption</b-form-checkbox>
                      </b-form-checkbox-group>
                    </b-form-group>
                    <b-form-group
                      id="input-group-cert"
                      label="Certificat"
                      label-for="cert"
                    >
                      <b-form-checkbox-group v-model="validate_cert" id="cert" disabled>
                        <b-form-checkbox value="cert">Activer la validation de certificat</b-form-checkbox>
                      </b-form-checkbox-group>
                    </b-form-group>
                    <b-form-group
                      id="input-group-protocol"
                      label="Protocol"
                      label-for="protocol"
                    >
                      <b-form-select v-model="protocol" :options="optionsProtocol" disabled></b-form-select>
                    </b-form-group>
                    <b-form-group
                      id="input-group-oag"
                      label="OAG"
                      label-for="oag"
                    >
                      <b-form-select v-model="selectedOag" :options="optionsOags"></b-form-select>
                    </b-form-group>
                    <b-form-group
                      id="input-group-oap"
                      label="OAP"
                      label-for="oap"
                    >
                      <b-form-select v-model="selectedOap" :options="optionsOaps"></b-form-select>
                    </b-form-group>
                    <button type="button" @click="addBal()" class="btn btn-primary">Valider</button>
                  </b-card>
                </b-collapse>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '@/utils/auth'
import { hasRule, rules as rules } from "@/utils/rulesHelper"
import { SlickList } from 'vue-slicksort'
import handleSlickItem from './slickBalItem'

export default {
  components: {
    SlickList,
    handleSlickItem
  },
  data() {
    return {
      groupBals: [],
      nom: '',
      host: '',
      port: null,
      login: '',
      mdp: '',
      encryption: [],
      validate_cert: [],
      oags: [],
      selectedOag: null,
      optionsOags: [],
      oaps: [],
      selectedOap: null,
      optionsOaps: [],
      protocol: 'imap',
      optionsProtocol: [{'value': 'imap', 'text': 'Imap'}],
      errors: {
        nom: '',
        host: '',
        port: '',
        login: '',
        mdp: '',
        oag: '',
        oap: ''
      }
    }
  },
  mounted() {
    this.all();
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl()
    this.$axios.defaults.headers.common['Authorization'] = getIdToken() + ' ' + getAccessToken()
    this.$axios.defaults.headers.common['Accept'] = 'application/json'
    this.$axios.defaults.headers.common['Provider'] = getProvider()
    this.allOags();
    this.allOaps();
  },
  methods: {
    all() {
      let self = this;
      let dataPost = {
        'provider': getProvider()
      }
      this.$store.commit('IS_LOADING', true)
      this.$axios
        .post('/administration/bals/list', dataPost)
        .then(response => {
          this.$store.commit('IS_LOADING', false)
          this.groupBals = _.groupBy(response.data.bals,'entreprise')
        })
        .catch(function(error) {
          self.$store.commit('IS_LOADING', false)
          self.$swal({
            position: 'top',
            type: 'error',
            title: 'Attention !!',
            text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
            showConfirmButton: false,
            timer: 5000
          });
        });
    },
    allOags() {
      this.$axios
        .get("/referentielClient/oag")
        .then(response => {
          this.oags = response.data.oags;
          this.optionsOags = response.data.oags.map(oag => {
            return {text: oag.code, value: oag.id}
          })
        });
    },
    allOaps() {
      this.$axios
        .get("/referentielClient/oap")
        .then(response => {
          this.oaps = response.data.oaps;
          this.optionsOaps = response.data.oaps.map(oap => {
            return {text: oap.code, value: oap.id}
          })
        });
    },
    sorted(event, newIndex, oldIndex, collection) {
      let self = this;
      let dataPost = {
        'provider': getProvider(),
        'groupBals': this.groupBals
      }
      this.$store.commit('IS_LOADING', true)
      this.$axios
        .post('/administration/bals/sort', dataPost)
        .then(response => {
          this.$store.commit('IS_LOADING', false)
          this.groupBals = _.groupBy(response.data.bals,'entreprise')
        })
        .catch(function(error) {
          self.$store.commit('IS_LOADING', false)
          self.$swal({
            position: 'top',
            type: 'error',
            title: 'Attention !!',
            text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
            showConfirmButton: false,
            timer: 5000
          });
        });
    },
    // toggleBalInfos(key, balId) {
    //   console.log(key)
    //   this.$root.$emit('bv::toggle::collapse', 'collapse-'+balId)
    //   // Gestion de la surbrillance de l'entête
    //   let elements = document.getElementsByClassName('block-'+key)
    //   for (let element of elements) {
    //     element.classList.remove("active")
    //   }

    //   let item = document.getElementById('item-'+balId)
    //   this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
    //     if(collapseId === 'collapse-'+balId && isJustShown) {
    //       item.classList.add("active")
    //     }
    //   })
    // },
    ajoutBal() {
      this.$root.$emit('bv::toggle::collapse', 'collapse-newBal')
    },
    addBal() {
      if (this.validateData()) {
        let self = this;
        let dataPost = {
          'provider': getProvider(),
          'nom': this.nom.trim(),
          'host': this.host.trim(),
          'port': this.port,
          'login': this.login.trim(),
          'mdp': this.mdp.trim(),
          'encryption': this.encryption === 'encryption' ? true : false,
          'validate_cert': this.validate_cert === 'cert' ? true : false,
          'protocol': this.protocol,
          'oag_id': this.selectedOag,
          'oap_id': this.selectedOap,
        }
        this.$store.commit('IS_LOADING', true)
        this.$axios
          .post('/administration/bals/add', dataPost)
          .then(response => {
            this.$store.commit('IS_LOADING', false)
            this.groupBals = _.groupBy(response.data.bals,'entreprise')
            this.resetInput()
            this.$root.$emit('bv::toggle::collapse', 'collapse-newBal')
          })
          .catch(function(error) {
            self.$store.commit('IS_LOADING', false)
            let errorText = "Une erreur est survenue pendant l\'enregistrement des informations, si le problème persiste merci de faire un ticket au support DOSI"
            if (error.response.status === 403) { errorText = "Vous n'êtes pas autorisé à effectuer cette action" }
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: errorText,
              showConfirmButton: false,
              timer: 5000
            });
          });
      }
    },
    toggleEditBal(balId, action) {
      let itemToShow
      let itemToHide

      if (action === 'cancel') {
        itemToShow = document.getElementById('infosMail-'+balId)
        itemToHide = document.getElementById('editMail-'+balId)
      } else if (action === 'edit') {
        itemToHide = document.getElementById('infosMail-'+balId)
        itemToShow = document.getElementById('editMail-'+balId)
      }
      
      itemToHide.classList.remove("d-block")
      itemToHide.classList.add("d-none")
      itemToShow.classList.remove("d-none")
      itemToShow.classList.add("d-block")
    },
    showEditBal(bal) {
      this.resetInput()
      this.nom = bal.nom
      this.host = bal.host
      this.port = bal.port
      this.login = bal.login
      this.encryption = bal.encryption === 'encryption' ? [bal.encryption] : []
      // console.log('typeof false',typeof false)
      this.validate_cert = bal.validate_cert === 'cert' ? [bal.validate_cert] : []
      this.protocol = bal.protocol ? bal.protocol : []
      this.selectedOag = bal.oag_id
      this.selectedOap = bal.oap_id
      this.toggleEditBal(bal.id, 'edit')
    },
    cancelEditBal(bal) {
      let itemToShow = document.getElementById('infosMail-'+bal.id)
      let itemToHide = document.getElementById('editMail-'+bal.id)
      this.resetInput()
      this.toggleEditBal(bal.id, 'cancel')
    },
    resetInput() {
      this.nom = ''
      this.host = ''
      this.port = null
      this.login = ''
      this.mdp = ''
      this.encryption = []
      this.validate_cert = []
      this.protocol = 'imap'
      this.selectedOag = null
    },
    modifyBal(bal) {
      // console.log('dans save : this.validate_cert', this.validate_cert)
      if (this.validateData('modify')) {
        let self = this;
        let dataPost = {
          'provider': getProvider(),
          'nom': this.nom.trim(),
          'host': this.host.trim(),
          'port': this.port,
          'login': this.login.trim(),
          'mdp': this.mdp.trim(),
          'encryption': this.encryption === 'encryption' ? true : false,
          'validate_cert': this.validate_cert === 'cert' ? true : false,
          'protocol': this.protocol,
          'oag_id': this.selectedOag,
          'oap_id': this.selectedOap,
          'balId': bal.id,
        }
        // console.log(dataPost)
        this.$store.commit('IS_LOADING', true)
        this.$axios
          .post('/administration/bals/edit', dataPost)
          .then(response => {
            this.$store.commit('IS_LOADING', false)
            this.groupBals = _.groupBy(response.data.bals,'entreprise')
            this.toggleEditBal(bal.id, 'cancel')
            this.resetInput()
          })
          .catch(function(error) {
            self.$store.commit('IS_LOADING', false)
            let errorText = "Une erreur est survenue pendant l\'enregistrement des informations, si le problème persiste merci de faire un ticket au support DOSI"
            if (error.response.status === 403) { errorText = "Vous n'êtes pas autorisé à effectuer cette action" }
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: errorText,
              showConfirmButton: false,
              timer: 5000
            });
          });
      }
    },
    removeBal(balId) {
      this.$swal
        .fire({
          title: "Êtes-vous sûr?",
          text: "Voulez-vous vraiment supprimer cet boîte mail ?",
          type: "warning",
          reverseButtons: true,
          showCancelButton: true,
          allowOutsideClick: false,
          cancelButtonColor: "#ff1744",
          confirmButtonText: "Annuler",
          cancelButtonText: "Supprimer"
        })
        .then(result => {
          if (!result.value) {
            let self = this;
            let dataPost = {
              'provider': getProvider(),
              'balId': balId,
            }
            this.$store.commit('IS_LOADING', true)
            this.$axios
              .post('/administration/bals/remove', dataPost)
              .then(response => {
                this.$store.commit('IS_LOADING', false)
                this.groupBals = _.groupBy(response.data.bals,'entreprise')
              })
              .catch(function(error) {
                self.$store.commit('IS_LOADING', false)
                let errorText = "Une erreur est survenue pendant la suppression de la boîte mail, si le problème persiste merci de faire un ticket au support DOSI"
                if (error.response.status === 403) { errorText = "Vous n'êtes pas autorisé à effectuer cette action" }
                self.$swal({
                  position: 'top',
                  type: 'error',
                  title: 'Attention !!',
                  text: errorText,
                  showConfirmButton: false,
                  timer: 5000
                })
              })
          }
      })
    },
    validateData (exception) {
      this.clearErrors();
      let valid = true
      if (this.nom.trim() === '') {
        this.errors.nom = 'Le nom de la configuration est obligatoire'
        valid= false;
      }

      if (this.host.trim() === '') {
        this.errors.host = 'L\'Host du serveur de messagerie est obligatoire'
        valid= false;
      }

      if (!this.port) {
        this.errors.port = 'Le port du serveur de messagerie est obligatoire'
        valid= false
      }

      if (this.login.trim() === '') {
        this.errors.login = 'Le login de la boîte mail est obligatoire'
        valid= false
      }

      if (exception === undefined || exception != 'modify') {
        if (this.mdp.trim() === '') {
          this.errors.mdp = 'Le mot de passe du compte est obligatoire'
          valid= false
        }
      }

      if (this.selectedOag === null) {
        this.errors.oag = 'Le code OAG est obligatoire'
        valid= false
      }

      if (this.selectedOap === null) {
        this.errors.oap = 'Le code OAP est obligatoire'
        valid= false
      }

      return valid;
    },
    clearErrors() {
      this.errors.nom = ''
      this.errors.host = ''
      this.errors.port = ''
      this.errors.login = ''
      this.errors.mdp = ''
      this.errors.oag = ''
      this.errors.oap = ''
    },
    destroy(id) {

    },
    formatDate(textDate) {
      let date = textDate !== null ? new Date(textDate).toLocaleDateString('fr-FR') : '-'
      return date;
    },
    canManage() {
      return hasRule(rules.MANAGE_ADMIN_BAL)
    }
  }
}
</script>

<style scoped>
.list-group-item {
  cursor: pointer;
}
.active {
  /*background-color: blue;*/
}
</style>